import usePagination from '@/hooks/usePagination';
import { ClientsFilters, Maybe, SortType } from '@/types/schema';

import { useClientFilterQuery } from '../graphql/query/generated/clientFilter';

interface UseClientsProps {
  filters: ClientsFilters;
  sort?: Maybe<SortType[]>;
  pause?: boolean;
  pageSize?: number;
}

const useClientsQuery = ({ sort, filters, pause, pageSize }: UseClientsProps) => {
  const { data, isFetchingMore, error, refetch, fetchMore, isFetching, isLoading } = usePagination(
    useClientFilterQuery,
    { filters, sort },
    { edgeKey: 'clients', requestPolicy: 'cache-and-network', pause, pageSize },
  );

  return {
    isFetching,
    isFetchingMore,
    isLoading,
    error,
    clients: data,
    refetch,
    fetchMore,
  };
};

export default useClientsQuery;
